import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from '@core/state/user/user.reducers';


/**
 * Feature Selector
 **/
export const selectUserState = createFeatureSelector<fromUser.State>(fromUser.featureName);
export const selectClients = createSelector(selectUserState, state => state.clients);
export const selectDecorators = createSelector(selectUserState, state => state.decorators);